import axios from 'axios';
import { message } from 'antd'; // 如果你使用antd的提示组件，或者替换成你自己的提示组件

// 创建axios实例
const service = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL, // 从环境变量读取API基础地址
    timeout: 10000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    (config) => {
        // 在发送请求之前做些什么
        // 例如：如果有token，可以带上
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        // 可以在这里添加全局loading
        // showLoading();

        return config;
    },
    (error) => {
        // 对请求错误做些什么
        // hideLoading();
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    (response) => {
        // hideLoading();

        // 对响应数据做点什么
        const res = response.data;

        // 假设后端返回的数据格式为 { code: 200, data: {}, message: 'success' }
        if (res.code !== '200') {
            // 处理业务错误
            message.error(res.message || 'Error');
            return Promise.reject(new Error(res.message || 'Error'));
        } else {
            return res.data; // 返回实际需要的数据部分
        }
    },
    (error) => {
        // hideLoading();

        // 对响应错误做点什么
        if (error.response) {
            // 有响应但是状态码不在2xx范围内
            switch (error.response.status) {
                case 401:
                    // 处理未授权
                    message.error('未授权，请重新登录');
                    // 可以跳转到登录页
                    // window.location.href = '/login';
                    break;
                case 403:
                    message.error('拒绝访问');
                    break;
                case 404:
                    message.error('请求资源不存在');
                    break;
                case 500:
                    message.error('服务器错误');
                    break;
                default:
                    message.error(error.response.data.message || '请求失败');
            }
        } else if (error.request) {
            // 请求已经发出但没有收到响应
            message.error('无响应，请检查网络连接');
        } else {
            // 发送请求时出错
            message.error('请求错误：' + error.message);
        }

        return Promise.reject(error);
    }
);

/**
 * 封装get方法
 * @param {string} url 请求地址
 * @param {object} params 请求参数
 * @param {object} config axios配置
 */
export function get(url, params = {}, config = {}) {
    return service({
        method: 'get',
        url,
        params,
        ...config,
    });
}

/**
 * 封装post方法
 * @param {string} url 请求地址
 * @param {object} data 请求体数据
 * @param {object} config axios配置
 */
// export function post(url, data = {}, config = {}) {
//     return service({
//         method: 'post',
//         url,
//         data,
//         ...config,
//     });
// }

/**
 * 封装getFile方法，用来获取文件
 * @param url
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function getFile(url) {
    return new Promise(async (resolve) => {
        const res = await axios.get(url)
        if (res.status === 200) {
            resolve(res.data);
        }
        resolve(null);
    })
}

export default service;